if($('.type-detail').length){
    if($('.product-top .flag-tip').length){
        $('.p-image-wrapper').append('<sdiv class="buterflyDreamer"><span class="dreamer">Álompillangó<br> ajánlja!</span></div>')
    }   
}